// extracted by mini-css-extract-plugin
export default {"option":"styles_option__qcEcO","selected":"styles_selected__RcsrH"};